const Subtitle = ({ title, officer = '' }) => {
  return (
    <h3 className="sub-title">
      {title} {officer == '' ? '' : `(${officer})`}
    </h3>
  );
};

export default Subtitle;
